/**
 * 新增地址前的「重複地址」判斷（前端 UX 層提醒；後端 createCustomerAddress 仍會權威去重）。
 *
 * 依使用者拍板：只比對 full_address 字串。為了吸收大小寫 / 空白差異，比對前先正規化：
 * 去頭尾空白 + 移除所有空白字元。回傳清單中第一筆 full_address 正規化後相同的地址。
 */
export const normalizeFullAddress = (value?: string | null): string =>
  (value ?? "").replace(/\s+/g, "").trim();

export interface AddressLike {
  full_address?: string | null;
}

/**
 * 在既有地址清單中找出與 candidate（full_address 字串）相同的地址。
 * @returns 既有的那筆地址；找不到回 undefined。
 */
export const findDuplicateAddress = <T extends AddressLike>(list: T[] | null | undefined, candidate: string): T | undefined => {
  const target = normalizeFullAddress(candidate);
  if (!target) return undefined;
  return (list ?? []).find((a) => normalizeFullAddress(a.full_address) === target);
};
